import { HTMLEditor } from '../dom-tools/HTMLEditor';
import { RegExpUtility } from "../text/RegExpUtility";
import { ElementAttribute } from "../dom-tools/ElementAttribute";
import { SVGEditor } from "./SVGEditor";
import { Box2, Vector2 } from "three";
export class InskapeLayerNameAttribute
{
  readonly matcher:RegExp;
  readonly selector:string;

  constructor( matcher:RegExp, selector:string )
  {
    this.matcher = matcher;
    this.selector = selector;
  }
}

export class Inkscape
{
  private static _instance:Inkscape;
  static readonly groupMode = new ElementAttribute( "inkscape:groupMode" );
  static readonly layerValue = "layer";
  
  static get $()
  {
    if ( ! Inkscape._instance )
    {
      Inkscape._instance = new Inkscape();
    }

    return Inkscape._instance;
  }
  
  static setText( textTarget:SVGElement, text:string )
  {
    let first = textTarget.querySelector( "tspan" );
    let nested = first.querySelector( "tspan" );
    
    let textNodeTarget = nested || first;

    textNodeTarget.innerHTML = text;
  }
  
  static hasInkscapeID( element:SVGElement )
  {
    let type = element.nodeName;
    let idValue = element.getAttribute( "id" );

    if ( ! idValue )
    {
      return false;
    }

    if ( idValue.toUpperCase() != idValue )
    {
      return true;
    }

    let regexSource = RegExpUtility.toRegexSource( type ) + "\\d+";
    let matcher = new RegExp( regexSource );
    
    let matchResult = matcher.exec( idValue );

    return matchResult && matchResult[ 0 ].length === idValue.length;
  }


  static clearColorStyles( element:SVGElement )
  {
    let treeWalker = document.createTreeWalker( element );
    
    while ( treeWalker.nextNode() )
    {
      let currentNode = treeWalker.currentNode;

      if ( currentNode.nodeType === Node.ELEMENT_NODE )
      {
        
        let element = currentNode as SVGGElement;

        if ( element.style.fill !== "none" )
        {
          element.style.fill = "";
          element.style.removeProperty( "fill" );
        }

        if ( element.style.stroke !== "none" )
        {
          element.style.stroke = "";        
          element.style.removeProperty( "stroke" );
        }
        
      }

    } 
  }

  static setColorStyles( element:SVGElement, color:string )
  {
    let treeWalker = document.createTreeWalker( element );
    
    while ( treeWalker.nextNode() )
    {
      let currentNode = treeWalker.currentNode;

      if ( currentNode.nodeType === Node.ELEMENT_NODE )
      {
        
        let element = currentNode as SVGGElement;

        if ( element.style.fill !== "none" )
        {
          element.style.fill = color;
        }

        if ( element.style.stroke !== "none" )
        {
          element.style.stroke = color;
        }
        
      }

    } 
  }

  static getLayer( element:SVGElement, name:string )
  {
    let layers = Inkscape.getLayersByName( element, name );

    return layers.length === 0 ? null : layers[ 0 ];
  }

  /*static getLayer( element:SVGElement, name:string )
  {
    let treeWalker = document.createTreeWalker( element );
    
    while ( treeWalker.nextNode() )
    {
      let currentNode = treeWalker.currentNode;
      let nodeType = currentNode.nodeType;
      let nodeName = currentNode.nodeName.toLowerCase();
      
      if ( nodeType === Node.ELEMENT_NODE && nodeName === "g" )
      {

        let element = currentNode as SVGGElement;
        let label = element.getAttribute( "inkscape:label" );
        let groupMode = element.getAttribute( "inkscape:groupmode" );

        let isInkscapeLayer = "layer" === groupMode && label === name;        

        if ( isInkscapeLayer )
        {
          return element;
        }
      }

    }   

    return null;
  }
  */
  static convertLayerToAttribute( element:SVGElement, definition:InskapeLayerNameAttribute,
    clearColorStyles:boolean = true )
  {
    let layers = Inkscape.getLayersByRegex( element, definition.matcher );
      
    for ( let layer of layers )
    {
      console.log( "NEVER TESTED!" );
      let element = HTMLEditor.createElementFromCSSSelector( definition.selector );
      layer.appendChild( element );

      if ( clearColorStyles )
      {
        Inkscape.clearColorStyles( layer );
      }
    }      
  }

  static convertLayersToAttributes( element:SVGElement, definitions:InskapeLayerNameAttribute[],
    clearColorStyles:boolean = true )
  {
    for ( let definition of definitions )
    {
      Inkscape.convertLayerToAttribute( element, definition, clearColorStyles );   
    }    

  }

  static isInkscapeLayer( element:SVGElement )
  {
    let groupMode = element.getAttribute( "inkscape:groupmode" );
    let isInkscapeLayer = "layer" === groupMode;
    
    return isInkscapeLayer;
  }

  static getLayerName( element:SVGElement )
  {
    if ( ! Inkscape.isInkscapeLayer( element ) )
    {
      return null;
    }

    return element.getAttribute( "inkscape:label" );
  }


  

  static getLayers( element:SVGElement, name:string )
  {
    let treeWalker = document.createTreeWalker( element );
    let layers:SVGGElement[] = [];
    
    while ( treeWalker.nextNode() )
    {
      let currentNode = treeWalker.currentNode;

      if ( currentNode.nodeType === Node.ELEMENT_NODE && currentNode.nodeName.toLowerCase() === "g" )
      {
        let element = currentNode as SVGGElement;
        let label = element.getAttribute( "inkscape:label" );
        let groupMode = element.getAttribute( "inkscape:groupmode" );

        let isInkscapeLayer = "layer" === groupMode && label === name;        

        if ( isInkscapeLayer )
        {
          layers.push( element );
        }
      }

    } 

    return layers;
  }

  static getInkscapeLabel( element:SVGElement )
  {
    return  element.getAttribute( "inkscape:label" );
  }

  static getLayersByName( element:SVGElement, name:string )
  {
    let treeWalker = document.createTreeWalker( element );
    let layers:SVGGElement[] = [];
    
    while ( treeWalker.nextNode() )
    {
      let currentNode = treeWalker.currentNode;

      if ( currentNode.nodeType === Node.ELEMENT_NODE && currentNode.nodeName.toLowerCase() === "g" )
      {
        let element = currentNode as SVGGElement;
        let label = element.getAttribute( "inkscape:label" );
        let groupMode = element.getAttribute( "inkscape:groupmode" );

        let isInkscapeLayer = "layer" === groupMode && label === name;        

        if ( isInkscapeLayer )
        {
          layers.push( element );
        }
      }

    } 

    return layers;
  }

  allLayers( element:SVGElement )
  {
    let treeWalker = document.createTreeWalker( element );
    let layers:SVGGElement[] = [];
    
    while ( treeWalker.nextNode() )
    {
      let currentNode = treeWalker.currentNode;

      if ( currentNode.nodeType === Node.ELEMENT_NODE && currentNode.nodeName.toLowerCase() === "g" )
      {
        let element = currentNode as SVGGElement;        
        let groupMode = element.getAttribute( "inkscape:groupmode" );

        let isInkscapeLayer = "layer" === groupMode;        

        if ( isInkscapeLayer )
        {
          layers.push( element );
        }
      }

    } 

    return layers;
  }

  displayOnlyOneLayer( element:SVGElement, layerName:string, displayValue:string = "inline", 
    removeInvisible:boolean = false )
  {
    let layers = this.allLayers( element );
    
    if ( layers.length === 0 )
    {
      console.log( "No layers found while searching:", layerName, " in >>", element );
    }
    

    let visibleLayer = layers.find( l => l.getAttribute( "inkscape:label") === layerName );
    

    if ( ! visibleLayer )
    {
      console.log( "Did not found visible layer" );
      return;
    }


    let hidingLayers = layers.filter(
      l =>
      {
        if ( l === visibleLayer ){ return false; }
        
        let p = l.parentElement as Element;

        while ( p )
        {
          if ( p === visibleLayer )
          {
            return false;
          }

          p = p.parentElement;
        }

        return true;        

      }
    );

    if ( removeInvisible )
    {
      hidingLayers.forEach(
        h => 
        {
          if ( ! h.parentElement )
          {
            return;
          }

          h.parentElement.removeChild( h );
        }
      )      
    }
    else
    {
      hidingLayers.forEach( h => h.style.display = "none" );      
    }

    visibleLayer.style.display = displayValue;



  }

  static getLayersByRegex( element:SVGElement, regex:RegExp )
  {
    let treeWalker = document.createTreeWalker( element );
    let layers:SVGGElement[] = [];
    
    while ( treeWalker.nextNode() )
    {
      let currentNode = treeWalker.currentNode;

      if ( currentNode.nodeType === Node.ELEMENT_NODE && currentNode.nodeName.toLowerCase() === "g" )
      {
        let element = currentNode as SVGGElement;
        let label = element.getAttribute( "inkscape:label" );
        let groupMode = element.getAttribute( "inkscape:groupmode" );

        let isInkscapeLayer = "layer" === groupMode && regex.test( label );        

        if ( isInkscapeLayer )
        {
          layers.push( element );
        }
      }

    } 

    return layers;
  }

  cloneDocument( document:Document ):Document
  {
    
    var newDocument = document.implementation.createDocument( ( document as any ).namespaceURI, null, document.doctype );

    newDocument.importNode( document.documentElement, true );

    return newDocument;
  }

  
  load( path:string ):Promise<Document>
  {
    let promise = new Promise<Document>
    (
      ( resolve, reject ) =>
      {
        let xhr = new XMLHttpRequest();
        xhr.open( "GET", path );
        xhr.onload = () =>
        {
          let data = xhr.responseXML;
          resolve( data );
        }

        xhr.onerror = e =>
        {
          reject( e );
        } 

        xhr.send();

      }     
      
    );

    return promise;
  }
}
